import React from "react";
import Header from "../../../components/Header/Header";
import {Button, Card, CardImg, Col, Container, Row} from "reactstrap";
import SectionPolygon from "../../../components/SectionPolygon/SectionPolygon";
import {lang, language} from "../../../const/language";
import VideoPLayer from "../../../components/VideoPlayer/VideoPLayer";
import './ViewSelectedCourse.scss'
import AuthButtonGroup from "../../../components/AuthButtonGroup/AuthButtonGroup";
import moment from "moment";
import * as commonFunc from "../../../utils/commonFunc";
import * as constants from "../../../const/constants";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import * as courseService from "../../../services/courses";
import GetCoursePaymentDetails from "../../../components/Modals/payeMentDetailsCourse/getCoursePaymentDetails";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import * as commonFun from '../../../utils/commonFunc'
import GetPaymentModel from "../../../components/Modals/payeMentDetailsCourse/getPaymentModel";

class ViewSelectedCourse extends React.Component {
    state = {
        courseId: '',
        course: undefined,
        selectCourse: undefined,
        viewModel: false,
        selectedInstallment: '',
        selectedInstallmentAmount: '',
        userType: '',
        lessonToCourse: [],
        installmentPaymentType: '',
        firstViewModel: '',
        isQuizAvailable:false
    };


    async componentDidMount() {
        window.scrollTo(0,0);
        let state = this.props.location.state;
        this.props.spinnerHandler({isSpin: true, type: 15});
        await this.setState({course: state.courseDetails});
        await this.setState({userType: state.userType});
        await this.setState({courseId: state.courseId});
        await this.setState({viewModel: state.showPayment});
        await this.setState({selectedInstallment: state.installmentId});


        await courseService.searchCourse(state.courseId).then(

            res => {

                if (res.success) {
                    this.setState({
                        selectCourse: res.body
                    });

                    this.setState({
                        installmentPaymentType:
                        this.state.selectCourse.courseEnrollType,
                        isQuizAvailable:res.body.quizAvailable
                    });
                    this.props.spinnerHandler(false);
                }
                console.log(res.body.quizAvailable);

            }
        ).catch(err => {
            console.log(err)
        });

        await courseService.searchCourseLesson(this.state.courseId).then(res => {
            if (res.success) {
                this.setState({lessonToCourse: res.body})
            } else {
                console.log(res)
            }
        }).catch(err => {
            console.log(err)
        });


    }

    payInstallment = async (installmentId, amount) => {

        await this.setState({selectedInstallment: installmentId, viewModel: true, selectedInstallmentAmount: amount});
    };
    viewModel = () => {
        this.setState({viewModel: false})
    };
    FirstViewModel = (obj) => {
        console.log(obj);
        this.setState({selectedInstallment: obj.installmentId});
        this.setState({firstViewModel: false});
        // this.setState({selectedInstallment: 2})
    };

    viewLessonsInCourse = (lessonList) => {

        let obj = {
            history: this.props.history,
            userType: this.props.location.state.userType
        };

        commonFunc.viewClassResources(obj, this.props.location.state);
    };

    viewCoursePapers = (course) => {
        let isClass = false;
        console.log(this.props);
        commonFunc.viewPaperResources(this.props, course.courseId, isClass);
    };


    onBack = () => {

        window.history.back();
    };

    JoinToClass = () => {
        console.log(this.props);


        let obj = {
            id: this.state.courseId,
            name: this.state.selectCourse.name
        };

        commonFun.joinCourseHandler(this.props, obj).then(res => {
            console.log(res)
        })


        // courseService.joinToLesson(course.courseId).then(
        //     res => {
        //         console.log(this.props);
        //         if (res.success) {
        //
        //         } else {
        //             commonFun.notifyMessage(res.message, 0);
        //             console.log(res)
        //         }
        //
        //     }
        // ).catch(err => {
        //     console.log(err);
        // })

    };

    registerForCourse = () => {
        if (this.state.userType !== 1) {
            this.props.history.push({
                pathname: `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`,
            })
        } else {
            //console.log(this.state.userType);
            this.setState({firstViewModel: true});
            this.setState({subNavigation: true});
        }
    };

    paymentModal = () => {
        this.setState({viewModel: true})
    };

    render() {
        let course = this.state.course;
        let selectedCourse = this.state.selectCourse;
        console.log(course);
        console.log(this.state.isQuizAvailable);
        return (

            //  <div className={userType !== 1 ?"guest-user-view-class lec-view-class":"lec-view-class"}>
            course !== undefined &&
            <div className={"lec-view-class"}>
                {this.state.firstViewModel ?
                    <GetPaymentModel history={this.props.history} courseId={this.state.courseId}
                                     courseDetails={this.state.course} closeModal={this.FirstViewModel}
                                     userType={this.state.userType}
                                     paymentModal={this.paymentModal}
                                     secondNav={this.state.subNavigation}
                    /> : null}

                {this.state.viewModel ?
                    <GetCoursePaymentDetails history={this.props.history} userType={this.state.userType}
                                             courseId={this.state.courseId}
                                             installmentId={this.state.selectedInstallment === '' ? this.props.location.state.installmentId : this.state.selectedInstallment}
                                             totalPayment={this.props.location.state.totalPayment}
                                             closeModal={this.viewModel}
                                             amount={this.state.selectedInstallmentAmount != '' ? this.state.selectedInstallmentAmount : this.state.course.totalFee}/> : null}
                <Header/>
                <Row>
                    <Col className={"col-poly"}>
                        <SectionPolygon/>
                    </Col>
                </Row>

                <div>
                    <main ref="main">
                        <section className={"section "}>
                            <Container className="  abouts ">
                                <Row className="about">
                                    <Col className={"col-img"}>
                                        <button className={"home-btn"}
                                                onClick={this.onBack}
                                        >
                                            <i className="icofont-long-arrow-left"/>
                                            {language[lang].BackToTour}
                                        </button>
                                        {
                                            course.videoUrl ?
                                                <div className={"videoHolder"}>
                                                    <Card className={"halfWidth"}>
                                                        {/*<Replay*/}
                                                        {/*    source={selectClass.videoUrl}*/}
                                                        {/*    initialPlaybackProps={{isPaused: true}}*/}
                                                        {/*>*/}
                                                        {/*    <HlsjsVideoStreamer/>*/}
                                                        {/*</Replay>*/}
                                                        <VideoPLayer class={true} video={course.videoUrl}/>
                                                    </Card>
                                                </div> :

                                                <Card className={"card-img"}>

                                                    <CardImg className={"main-img"} alt="."
                                                             src={course.imageUrl}/>
                                                </Card>
                                        }

                                    </Col>
                                </Row>

                                <br/>

                                <Row className="about">
                                    <Col lg="12" className={"col-name"}>
                                        <p className={"head-topic"}>{`${course.name}`}</p>

                                    </Col>
                                    <Col lg={12}>
                                        <div className={"lec-desc-wrapper"}>
                                            <p className={"lec-desc"}>{course.description}</p>
                                        </div>
                                    </Col>

                                </Row>

                                <Row className="about">

                                    {
                                        // selectClass.dayTimes.length !== 0 &&
                                        <Col lg="3" className={"col-shedule"}>
                                            <Card className={"card-shedule"}>
                                                <div>
                                                    <ul><p
                                                        className={"card-topic"}>{language[lang].ClassSchedule}</p>
                                                    </ul>

                                                    {
                                                        course.coursesDayTimes.length !== 0 ? course.coursesDayTimes.map((dayTime, i) => (
                                                                <ul key={(i + dayTime.day).toString()}
                                                                    className={"card-cont day-list"}>
                                                                    <li>
                                                                        <p
                                                                            key={i}>{`${language[lang][dayTime.day]}:`}</p>
                                                                        <p>

                                                                            {`${moment(`2000-01-01 ${dayTime.startTime}`).format('h:mm a')} to ${moment(`2000-01-01 ${dayTime.endTime}`).format('h:mm a')}`}
                                                                        </p>
                                                                    </li>
                                                                </ul>)) :
                                                            <ul>

                                                                <p style={{justifyContent: "center"}}>{language[lang].emptyTimeTableCourse}</p>
                                                            </ul>
                                                    }

                                                    {/*{*/}
                                                    {/*    (selectClass.nextDayOfClass !== undefined && selectClass.nextDayOfClass !== null) &&*/}
                                                    {/*    <ul className={"card-cont next-list"}>*/}
                                                    {/*        <li>*/}

                                                    {/*            <span> {`${language[lang].NextClassIsOn}`} </span></li>*/}
                                                    {/*        <p className={"next-day"}>*/}
                                                    {/*            {moment(selectClass.nextDayOfClass.replace("Z", "")).format("YYYY MMM DD")} </p>*/}
                                                    {/*    </ul>*/}
                                                    {/*}*/}

                                                </div>
                                            </Card>
                                        </Col>
                                    }

                                    {
                                        <Col xs={12} sm={12} lg="9" className={"col-syllebus"}>
                                            <Card className={"auto-width card-pur-months"}>

                                                {
                                                    this.state.selectCourse === undefined && this.state.installmentPaymentType != undefined || this.state.installmentPaymentType !== 'FULL' || course.buttonStatus === 'BUY' || this.state.userType === 0 ?
                                                        <div>
                                                            <ul><p
                                                                className={"card-topic"}>{language[lang].courseInstallment}</p>
                                                            </ul>
                                                            <Row style={{marginLeft: '2%'}}> <Col xm={12}>
                                                                <table style={{width: '100%'}}>
                                                                    <tbody>
                                                                    <tr>
                                                                        <th>
                                                                            {course.courseInstallmentList.map((value, index) => (
                                                                                <p key={(index + value.amount).toString()}
                                                                                   style={{paddingBottom: '5%'}}>{index + 1} {language[lang].installmentStatement}</p>
                                                                            ))}
                                                                        </th>

                                                                        <th style={{marginLeft: '2%'}}>
                                                                            {course.courseInstallmentList.map((value, index) => (
                                                                                <p key={(index + value.amount).toString()}
                                                                                   style={{paddingBottom: '5%'}}>Rs.{value.amount}.00</p>
                                                                            ))}
                                                                        </th>

                                                                        <th style={{paddingLeft: '2%'}}>
                                                                            {this.state.selectCourse !== undefined && this.state.userType !== 0 &&
                                                                            this.state.selectCourse.coursePaymentDetails.map((value, index) => (
                                                                                <div
                                                                                    key={(index + 'value').toString()}
                                                                                    style={{paddingBottom: '5%'}}>
                                                                                    {value.buttonStatus === 'BOUGHT' ?
                                                                                        <p className='installmentComplete'>Paid
                                                                                            !</p> :
                                                                                        value.buttonStatus === 'BUY' ?
                                                                                            <Button

                                                                                                onClick={() => this.payInstallment(value.studentInstallment.id, value.studentInstallment.amount)}
                                                                                                className='log-btn'>Pay</Button>
                                                                                            :
                                                                                            value.buttonStatus === 'PENDING' ?
                                                                                                <p className='installmentComplete'>
                                                                                                    <span>Payment sent for approval!</span>
                                                                                                </p>
                                                                                                : null

                                                                                    }

                                                                                </div>
                                                                            ))}
                                                                        </th>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </Col></Row>
                                                        </div> : null
                                                }


                                                {this.state.selectCourse === undefined && this.state.installmentPaymentType === 'FULL' && this.state.installmentPaymentType != undefined || this.state.userType === 0 ?
                                                    <ul><p
                                                        className={"card-topic"}> {language[lang].totalPayment} {course.totalFee}/=</p>
                                                    </ul> : null
                                                }

                                                {/*{this.props.location.state.courseDetails.buttonStatus === 'PENDING'?<small  style={{paddingLeft: '5%'}}>ඔබ මෙම පාඨමාලාව සඳහා ගෙවීමක් සිදුකර ඇත! ඔබගේ ගෙවීම් අනුමත කිරීමට යවනලදී. කරුණාකර රැදීසිටින්න! </small>:null}*/}

                                                <ul><p className={"card-topic"}>{language[lang].viewCourseDetails}</p>
                                                </ul>
                                                <div lg={12} md={12} sm={12}>
                                                    <ul>
                                                        <li>
                                                            <span> {language[lang].courseStartDate} : {course.startDate}</span>
                                                        </li>
                                                        <li>
                                                            <span>{language[lang].courseEndDate} : {course.endDate}</span>
                                                        </li>
                                                    </ul>
                                                </div>


                                                <div>
                                                    {this.state.selectCourse !== undefined && this.state.selectCourse.coursePaymentDetails !== null && this.state.installmentPaymentType === 'FULL' && this.state.selectCourse.coursePaymentDetails.map((value, index) => (
                                                        <div>
                                                            {value.buttonStatus === 'BOUGHT' ?
                                                                <ul style={{marginTop: '1%'}}
                                                                    className='installmentComplete successPayment'>
                                                                    {language[lang].fullPaymentSuccess}
                                                                </ul> : value.buttonStatus === 'PENDING' ?
                                                                    <ul className={"card-topic"}>{language[lang].fullPaymentAwait}</ul> : null
                                                            }
                                                        </div>
                                                    ))}

                                                </div>


                                            </Card>
                                        </Col>
                                    }


                                    <Col xs={12} sm={12} md={9} lg={9}>
                                        {this.props.location.state.courseDetails.buttonStatus === 'BOUGHT' ?
                                            <div style={{marginTop: '2%'}}>
                                                <Row>
                                                    <Col md={4}>
                                                        <Button
                                                            className="com-btn reg-btn"
                                                            onClick={this.JoinToClass}
                                                        >{language[lang].joinToLesson}</Button>
                                                    </Col>
                                                    <Col md={4}>
                                                        <Button
                                                            onClick={() => this.viewLessonsInCourse(this.state.lessonToCourse)}
                                                            className="com-btn  ">{language[lang].videosPDF}</Button>
                                                    </Col>
                                                   { this.state.isQuizAvailable ?
                                                        <Col md={4}>
                                                            <Button
                                                                onClick={() => this.viewCoursePapers(course)}
                                                                className="com-btn  ">{language[lang].QuizesAndTestPapers}</Button>
                                                        </Col>
                                                    : null }
                                                </Row>


                                            </div> : null

                                        }
                                        {this.props.location.state.courseDetails.buttonStatus === 'BUY' ?
                                            <div style={{marginTop: '2%'}}>
                                                <Row>
                                                    <Col md={4}>
                                                        <Button
                                                            className="com-btn reg-btn"
                                                            onClick={() => {
                                                                this.registerForCourse(selectedCourse)
                                                            }}
                                                        >{language[lang].registerForCourse}</Button>
                                                    </Col>
                                                </Row>
                                            </div> : null
                                        }
                                    </Col>

                                </Row>


                            </Container>
                        </section>
                    </main>
                    <CardsFooter/>
                </div>
            </div>

        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});
export default connect('', mapDispatchToProps)(withRouter(ViewSelectedCourse));


// export default ViewSelectedCourse;